export const MENU_ID = 'project/next-gen';

export const SECTION_ID = {
	ISSUES: 'issues',
	REPORTS: 'reports',
	SETTINGS: 'settings',
	ISSUE_TYPES: 'issuetypes',
	BOARD_SETTINGS: 'boards',
} as const;

export const JIRA_AUTOMATION_ADDON_KEY = 'com.codebarrel.addons.automation';
